module.exports = __webpack_public_path__ + "img/facebook.61a96c78.png";